<template>
  <div class="page-container base-batch-list">
    <div class="page-title-container">
      <h1 class="page-title">Entregables</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <button
                type="button"
                class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters"
              >
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-flex d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por nombre, documento, distrito o zonal"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />

              <div class="text-right mt-2 mt-md-0">
                <b-button
                  :to="{ name: 'celulares-deliverables-create' }"
                  variant="none"
                  class="button button-primary ml-md-2"
                  >Agregar</b-button
                >
              </div>
            </div>
          </section>

          <filter-menu
            :show="showFilters"
            @hide="showFilters = false"
            :options="filterOptions"
            :selectedOptionFilter="filters"
            @setFilters="setFilters"
          ></filter-menu>
        </div>

        <div
          class="w-100 d-flex flex-wrap align-items-center mt-2"
          v-if="showFiltersList"
        >
          <span
            v-for="(val, name) in filterList"
            v-bind:key="name"
            class="filter-item"
          >
            {{ getFilterName(name, val) }}
            <button
              type="button"
              class="text-white p-0 bg-transparent border-0 ml-2"
              @click="deleteFilter(name)"
            >
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div class="mb-0">
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Codigo Impulsador</span>
            </div>

            <div>
              <span>Nombre y Apellidos</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <a href="" @click.prevent="download(o.file)" class="mr-2"
                  >Descargar</a
                >

                <router-link
                  :to="{
                    name: 'celulares-status-details',
                    params: { batchId: o.id },
                  }"
                  class="mr-2"
                  >Ver detalle</router-link
                >
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Distrito:</span
                    >
                    <span></span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Zonal:</span
                    >
                    <span></span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >N° Recargador:</span
                    >
                    <span></span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Código Bolsa:</span
                    >
                    <span></span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Estado:</span
                    >
                    <span></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>Codigo Impulsador</th>
              <th>Nombre y Apellidos</th>
              <th>Distrito</th>
              <th>Zonal</th>
              <th>N° Recargador</th>
              <th>Código Bolsa</th>
              <th>Estado</th>
              <th class="pr-md-3">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="cell-center px-1"></td>
              <td class="cell-center"></td>
              <td class="cell-center"></td>
              <td class="cell-center"></td>
              <td class="cell-center"></td>
              <td class="cell-center">
              </td>
              <td class="cell-center d_option pr-md-2 position-relative">
                <DropdownTable>
                  <template v-slot:dropdown-content>
                    <DropdownItem
                      text="Descargar"
                      @click="download(o.file)"
                      v-if="o.file"
                    />
                    <DropdownItem
                      text="Ver detalle"
                      :to="{
                        name: 'celulares-status-details',
                        params: { batchId: o.id },
                      }"
                    />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
          v-if="list.length"
        />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">No se encontraron resultados que coincidan con los criterios seleccionados.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DeliverableService } from "../../Core/Services";

import geoDataMixin from '@/core/Mixins/geoDataMixin'

import {
  Alert,
  Constants,
  DropdownItem,
  DropdownTable,
  FilterMenu,
  FilterMixin,
  PaginationMixin,
  SearchBar,
  Util,
} from "wize-admin";

import { Constants as LocalConstants } from "@/core/utils";

export default {
  mixins: [FilterMixin, PaginationMixin, geoDataMixin],
  components: {
    SearchBar,
    DropdownTable,
    DropdownItem,
    FilterMenu
  },
  data() {
    return {
      list: [],
      tooltipType: null,
      pageSize: 100,
      districtList: [],
      zonalList: [],
      filterOptions: [
      {
          label: "Zonal",
          key: "zonal",
          type: Constants.TypeFilters.MULTIPLE,
          options: []
        },
        {
          label: "Estado",
          key: "status",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.DeliverablesStatus.ACTIVE,
            LocalConstants.DeliverablesStatus.INACTIVE,
          ]
        },
        {
          label: "Distrito",
          key: "district",
          type: Constants.TypeFilters.MULTIPLE,
          options: []
        }
      ],
    };
  },
  methods: {
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);

        const params = {
          page: this.page - 1,
          size: this.pageSize,
          sort: "id,desc",
        };

        const data = { search: this.search, ...this.filters };
        const response = await DeliverableService.list(data, params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    download(asset) {
      if (asset) Util.downloadFile(asset.url, asset.name);
    },
  },
  async mounted() {
    // await this.loadData();

    let zonalFilterOption = this.filterOptions.find(item => item.key == 'zonal')
    zonalFilterOption.options = this.zonalList

    let districtFilterOption = this.filterOptions.find(item => item.key == 'district')
    districtFilterOption.options = this.districtList
  },
  async created() {},
};
</script>

<style lang="stylus" scoped></style>
